import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import {AppSettings} from '../../app-settings';
import {HttpClientService} from '../../Services/http-client.service';
import { HttpHeaders } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import {SessionService} from '../../Services/session.service';
import {Subscription} from 'rxjs';
import { EventService } from "../../Services/event.service";

@Component({
  selector: 'app-forum-post',
  templateUrl: './forum-post.component.html',
  styleUrls: ['../bookmarks/bookmarks.component.css','./forum-post.component.css']
})
export class ForumPostComponent implements OnInit, OnDestroy {

	tabPro:String = "tabPro";
	tabSec:String = "tabSec";
	tabActive:String ="tabPro";
  tableRowHover:boolean = false;
	profileTabImg  = AppSettings.cdnUrl +"assets/images/play-button-bg.png";
  securityTabimg = AppSettings.cdnUrl+"assets/images/test-bg.png";
  //green_tick_img = AppSettings.cdnUrl+"assets/images/green_tick.png";
  //red_tick_img   = AppSettings.cdnUrl+"assets/images/timesw.png";
  loadingCircleURL = AppSettings.loadingCircleImageURL;
  dataLoaded:boolean = true;
  no_form_concept:boolean = false;
  forumsConcept = [];
  forumsConceptAll = [];
  forumsQuiz = [];
  forumsQuizAll = [];
  forumConceptObject:any={};
  forumsConceptDummy = [] ;
  forumsQuizDummy = [];
  courseDataLoaded:boolean = true;

  public filterQuery = "";
  public sortBy = "quiz";
  public sortOrder = "asc";
  questionCharacterCount:number = 144;
  questionHeadingCount:number = 40;
  serverErrorFlagConcepts:boolean = false;
  serverErrorFlagNotes:boolean = false;
  userInfoSubscription:Subscription;
  userEmail:string;

  constructor(private httpClientService: HttpClientService , private sanitizer: DomSanitizer, private sessionService: SessionService, private eventService: EventService) { }

  ngOnInit() {

    this.getForumsThreadData();
    this.getFullName();
  }

  getFullName()
  {

    this.userInfoSubscription = this.sessionService.getUserInfo$.
    subscribe(data => { if(data != "")
     this.userEmail = data.username;
     if(this.userEmail)
     {
        this.fireAccessedEvent();
     }
      });

   }

  fireAccessedEvent()
  {
    this.eventService.track('Accessed_User_Info', {"Accessed_Reason":"forum_posts"}, this.userEmail);
  }
   toggle(tabName:String, vevent)
  {

  	this.tabActive = tabName;
  }
  posBlock(event)
  {
    var popUp = event.target.querySelectorAll(".pop_block")[0];
    var popUpHeight = popUp.offsetHeight;
    var tableRowHeight = event.target.parentElement.offsetHeight;
    popUp.style.top = ((tableRowHeight - popUpHeight)/2)+"px";
  }
  getForumsThreadData()
  {
      let headers = new HttpHeaders();
      this.httpClientService.get(AppSettings.restApiUrl+'/api/user/concepts/forums/'
          , headers)
      .subscribe(
      (data) => {
                  if(data.forumThreads != null)
                  {
                  this.forumsConceptDummy = data.forumThreads;
                  var conceptForumsLength = this.forumsConceptDummy.length;
                  for(var i=0; i<conceptForumsLength;i++)
                  {
                      this.forumConceptObject = {};
                      if(this.forumsConceptDummy[i].forumQuestion != null)
                      {
                        this.forumConceptObject.forumQuestion = this.sanitizer.bypassSecurityTrustHtml(this.forumsConceptDummy[i].forumQuestion.replace(/<\s*(\w+).*?>/, '<$1>').replace(/&nbsp;/gi,''));
                      }
                      else
                      {
                        this.forumConceptObject.forumQuestion = this.sanitizer.bypassSecurityTrustHtml('null');
                      }
                      this.forumConceptObject.conceptName = this.forumsConceptDummy[i].conceptName;
                      this.forumConceptObject.forumQueryDate = this.forumsConceptDummy[i].forumQueryDate;
                      if(this.forumsConceptDummy[i].archived)
                      {
                        this.forumConceptObject.url = "/archived/forum/"+this.forumsConceptDummy[i].correlationId;
                      }
                      else
                      {
                        this.forumConceptObject.url = "/forum/"+this.forumsConceptDummy[i].correlationId;
                      }

                      this.forumConceptObject.hoverOver = false;
                      if(this.forumsConceptDummy[i].hasExpertResponse)
                      {
                          this.forumConceptObject.hasExpertResponse = true;
                      }
                      else
                      {
                          this.forumConceptObject.hasExpertResponse = false;
                      }
                      this.forumsConcept.push(this.forumConceptObject);
                  }
                  this.forumsConceptAll = this.forumsConcept;
                  }
                  this.dataLoaded = false;
      },(e)=>{

          if(e.status == 500)
          {
             this.serverErrorFlagConcepts = true;
          }
          this.dataLoaded = false;
      });

      let header = new HttpHeaders();
      this.httpClientService.get(AppSettings.restApiUrl+'/api/user/quiz/forums/'
          , header)
      .subscribe(
      (data) => {
                  if(data.forumThreads != null)
                  {
                  this.forumsQuizDummy = data.forumThreads;
                  var quizForumsLength = this.forumsQuizDummy.length;
                  for(var i=0; i<quizForumsLength;i++)
                  {
                      this.forumConceptObject = {};
                      if(this.forumsQuizDummy[i].forumQuestion != null)
                      {
                        this.forumConceptObject.forumQuestion = this.sanitizer.bypassSecurityTrustHtml(this.forumsQuizDummy[i].forumQuestion.replace(/<\s*(\w+).*?>/, '<$1>').replace(/&nbsp;/gi,''));
                      }
                      else
                      {
                        this.forumConceptObject.forumQuestion = this.sanitizer.bypassSecurityTrustHtml('null');
                      }
                      this.forumConceptObject.quizName = this.forumsQuizDummy[i].quizName;
                      this.forumConceptObject.forumQueryDate = this.forumsQuizDummy[i].forumQueryDate;
                      this.forumConceptObject.url = this.forumsQuizDummy[i].url;
                      this.forumConceptObject.hoverOver = false;
                      if(this.forumsQuizDummy[i].hasExpertResponse)
                      {
                          this.forumConceptObject.hasExpertResponse = true;
                      }
                      else
                      {
                          this.forumConceptObject.hasExpertResponse = false;
                      }
                      this.forumsQuiz.push(this.forumConceptObject);
                  }
                  this.forumsQuizAll = this.forumsQuiz;
                  }
                  this.dataLoaded = false;
      },(e)=>{

          if(e.status == 500)
          {
             this.serverErrorFlagNotes = true;
          }
          this.dataLoaded = false;
      });
  }

  @HostListener('unloaded')
  ngOnDestroy(): void {
    this.userInfoSubscription.unsubscribe();
  }

}
